"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedInventoryArticle = void 0;
var constants_1 = require("../constants");
var RichArticle_1 = require("./RichArticle");
var generatePTProductSku = function (ptInventoryArticle) {
    var ptProductSku = '';
    var game = ptInventoryArticle.card.idGame;
    var expansionCode = ptInventoryArticle.card.set;
    var cn = ptInventoryArticle.card.cn;
    var condition = ptInventoryArticle.condition;
    var language = ptInventoryArticle.idLanguage;
    ptProductSku = "".concat(game, "_").concat(expansionCode, "_").concat(cn, "_").concat(condition, "_").concat(language);
    if (ptInventoryArticle.finishType === constants_1.FINISH_TYPE_LABELS.FOIL) {
        ptProductSku += '_F';
    }
    if (ptInventoryArticle.isRainbowFoil) {
        ptProductSku += '_Rf';
    }
    if (ptInventoryArticle.isColdFoil) {
        ptProductSku += '_Cf';
    }
    if (ptInventoryArticle.finishType === constants_1.FINISH_TYPE_LABELS.REVERSE_HOLO) {
        ptProductSku += '_Rh';
    }
    if (ptInventoryArticle.isSigned) {
        ptProductSku += '_1';
    }
    if (ptInventoryArticle.isFirstEd) {
        ptProductSku += '_S';
    }
    return ptProductSku;
};
var AggregatedInventoryArticle = /** @class */ (function (_super) {
    __extends(AggregatedInventoryArticle, _super);
    function AggregatedInventoryArticle(params) {
        var _this = _super.call(this, params.article) || this;
        _this.sku = generatePTProductSku(params.article);
        _this.hasConflict = params.hasConflict;
        _this.isSelectedForConflictResolution = params.isSelectedForConflictResolution;
        _this.isProcessed = params.isProcessed;
        _this.conflictFields = params.conflictFields;
        _this.prices = params.prices;
        _this.minPrice = params.minPrice;
        _this.avgPrice = params.avgPrice;
        _this.maxPrice = params.maxPrice;
        _this.selectedPrice = params.selectedPrice;
        _this.source = params.source;
        _this.locations = params.locations;
        return _this;
    }
    return AggregatedInventoryArticle;
}(RichArticle_1.RichArticle));
exports.AggregatedInventoryArticle = AggregatedInventoryArticle;
//# sourceMappingURL=AggregatedInventoryArticle.js.map